import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService, NotificationService } from '@services';
import { Observable, catchError } from 'rxjs';

export function authorizationInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const authService = inject(AuthService);
  const notificationService = inject(NotificationService);
  const user = authService.user();

  let authRequest: HttpRequest<unknown> = req;
  if (user !== null) {
    authRequest = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${user.token}`),
    });
  }

  return next(authRequest).pipe(
    catchError((err) => {
      if (err?.status === 401 && user) {
        authService.logout();
        notificationService.warning(
          'You have been logged out due to inactivity.',
        );
      }

      throw err;
    }),
  );
}
